import { useState, useEffect } from "react";
import { BiSun } from "react-icons/bi";
import { IoMenuOutline } from "react-icons/io5";
import { HiMoon } from "react-icons/hi";
import StickyNav from "./StickyNav";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isDark, setIsDark] = useState<boolean>(false);
  const [stickyNav, setstickyNav] = useState<boolean>(false);

  //if user scrolls down, setStickyNav to true
  const handleScroll = () => {
    if (window.scrollY > 400) {
      setstickyNav(true);
    } else {
      setstickyNav(false);
    }
  };

  const NavLinks: string[] = ["About", "Projects", "Contact"];

  useEffect(() => {
    //check if dark mode is enabled
    if (localStorage.theme === "dark") {
      setIsDark(true);
    } else {
      setIsDark(false);
    }

    handleScroll();
    //add event listener to window
    window.addEventListener("scroll", handleScroll);
  }, []);

  const toggleDarkMode = (): void => {
    if (localStorage.theme === "dark") {
      localStorage.theme = "light";
      setIsDark(false);
      document.documentElement.classList.remove("dark");
    } else {
      localStorage.theme = "dark";
      setIsDark(true);
      document.documentElement.classList.add("dark");
    }
  };

  const toggleNav = (): void => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <header>
        {stickyNav && (
          <StickyNav
            toggleNav={toggleNav}
            isOpen={isOpen}
            navLinks={NavLinks}
            toggleDarkMode={toggleDarkMode}
            isDark={isDark}
          />
        )}
        <nav className="h-20 flex items-center mx-auto max-w-3xl px-4">
          <button className="font-medium font-sans text-lg mr-auto dark:text-white ">
            Asifur Rahaman
          </button>
          <ul className="flex items-center">
            {NavLinks.map((link, i) => (
              <li className="mx-2 hidden sm:inline" key={i}>
                <a
                  href={`#${link}`}
                  className="hover:text-primary dark:hover:text-primary dark:text-white transition-colors"
                >
                  {link}
                </a>
              </li>
            ))}

            <li className="relative flex w-7 sm:hidden mr-2">
              <button onClick={toggleNav}>
                <IoMenuOutline
                  id="hamberger"
                  className="dark:text-white text-3xl"
                />
              </button>

              {isOpen && (
                <ul
                  id="navbar"
                  className="dark:text-slate-400 sm:hidden dark:bg-slate-800  absolute py-3 top-8 right-0 bg-white w-40 rounded-md shadow-lg dark:shadow-grey"
                >
                  {NavLinks.map((link, i) => (
                    <li
                      key={i}
                      className="flex items-center justify-center py-3"
                    >
                      <a href={`#${link}`} className="w-full text-center">
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </li>
            <li className="flex w-7 ml-2">
              <button
                onClick={toggleDarkMode}
                className="p-2 bg-grey dark:bg-white rounded-md text-xl sm:text-base"
              >
                {isDark ? <BiSun /> : <HiMoon />}
              </button>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
}
